<!--
  Angular 15: *ngIf / *ngFor only, no @if blocks.
-->
<div class="dl-page">

  <div class="dl-page__header">
    <div class="dl-page__heading">
      <h1 class="dl-page__title">Material catalogs</h1>
      <p class="dl-page__subtitle">
        Global catalogs that tenants with "Material catalogs" switched on can import materials from.
        Tenants only see published ones.
      </p>
    </div>
    <div class="dl-page__actions">
      <a class="dl-btn" routerLink="/catalogs/manufacturers" data-testid="catalogs-manufacturers-link">
        <mat-icon>factory</mat-icon>
        Manufacturers
      </a>
      <button type="button" class="dl-btn dl-btn--primary" (click)="openCreate()" data-testid="catalogs-new">
        <mat-icon>add</mat-icon>
        New catalog
      </button>
    </div>
  </div>

  <div class="dl-loading" *ngIf="loading">
    <div class="dl-spinner"></div>
    <p>Loading…</p>
  </div>

  <div class="dl-banner dl-banner--error" *ngIf="error">
    <mat-icon>error</mat-icon>
    <div class="dl-banner__body">{{ error }}</div>
    <div class="dl-banner__actions">
      <button type="button" class="dl-btn dl-btn--sm" (click)="load()">Try again</button>
    </div>
  </div>

  <app-empty-state icon="menu_book" title="No catalogs" *ngIf="!loading && !error && catalogs.length === 0">
    Create the first catalog, then upload its CSV.
  </app-empty-state>

  <div class="dl-card" *ngIf="!loading && catalogs.length > 0" [class.dl-is-refreshing]="refreshing">
    <table class="dl-table dl-table--cards" dlCardTable data-testid="catalogs-table">
      <thead>
        <tr>
          <th>Code</th>
          <th>Name</th>
          <th>Status</th>
          <th class="dl-table__numeric">Version</th>
          <th class="dl-table__numeric">Materials</th>
          <th class="dl-table__numeric">Packages</th>
          <th>Updated</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let catalog of catalogs; trackBy: trackById"
            class="dl-row--clickable"
            (click)="open(catalog)"
            [attr.data-testid]="'catalog-row-' + catalog.code"
            [attr.data-status]="catalog.status">
          <td><code class="catalog-code">{{ catalog.code }}</code></td>
          <td class="dl-cell--title">
            {{ catalog.name }}
            <div class="catalog-description" *ngIf="catalog.description">{{ catalog.description }}</div>
          </td>
          <td><span [ngClass]="statusClass(catalog.status)">{{ statusLabel(catalog.status) }}</span></td>
          <td class="dl-table__numeric">v{{ catalog.version }}</td>
          <td class="dl-table__numeric">{{ catalog.materialCount }}</td>
          <td class="dl-table__numeric">{{ catalog.packageCount }}</td>
          <td>{{ catalog.updatedAt ? (catalog.updatedAt | date:'dd.MM.yy HH:mm') : '—' }}</td>
          <td class="dl-cell--bare">
            <button type="button" class="dl-btn dl-btn--ghost dl-btn--icon"
                    (click)="openEdit(catalog, $event)" matTooltip="Edit" aria-label="Edit"
                    data-testid="catalog-edit">
              <mat-icon>edit</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-catalog-form-dialog
  [isOpen]="formOpen"
  [catalog]="editing"
  (saved)="onSaved($event)"
  (cancel)="formOpen = false">
</app-catalog-form-dialog>
